import { Button } from "components/Button";
import { TSuggestion } from "types/suggestions";

type TProps = {
  suggestion: TSuggestion;
  isSelected: boolean;
  onSelect: () => void;
  onApprove: () => void;
  isOnApprove: boolean;
};

export const Suggestion = ({ isSelected, onSelect, suggestion, onApprove, isOnApprove }: TProps) => {
  return (
    <tr className="">
      <td className="p-2 text-center">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="cursor-pointer accent-[#FFC93D] w-4 h-4"
        />
      </td>

      <td className="p-2 text-center">
        {suggestion.suggestionCount}
      </td>

      <td className="p-2">
        <a
          href={`https://x.com/${suggestion.twitter}`}
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          {suggestion.twitter}
        </a>
      </td>

      <td className="flex-1 p-2 text-center">
        <Button
          extraClass="h-[28px] py-0 px-2 w-fit" onClick={onApprove}
          disabled={isOnApprove}
        >
          Approve
        </Button>
      </td>
    </tr>
  );
};
